import React, { useState, useEffect } from 'react'
import Helmet from 'react-helmet'

import { Footer } from './Footer'
import { Navigation } from './Navigation'
import { Sidebar } from './Sidebar'
import favicon from '../assets/images/nav-logo.png'
import config from '../utils/config'

import '../styles/style.css'
import '../styles/new-moon.css'

export const Layout = ({ children }) => {
  const [theme, setTheme] = useState('dark')

  const handleUpdateTheme = (newTheme) => {
    window.localStorage.setItem('theme', newTheme)
    document.documentElement.style.setProperty('color-scheme', newTheme)

    if (document.querySelector('.utterances-frame')) {
      const theme = newTheme === 'light' ? 'github-light' : 'github-dark'
      const message = {
        type: 'set-theme',
        theme: theme,
      }
      const iframe = document.querySelector('.utterances-frame')
      iframe.contentWindow.postMessage(message, 'https://utteranc.es')
    }

    setTheme(newTheme)
  }

  useEffect(() => {
    const savedTheme = window.localStorage.getItem('theme')

    if (savedTheme) {
      setTheme(savedTheme)
      document.documentElement.style.setProperty('color-scheme', savedTheme)
    }
  }, [])

  return (
    <div>
      <Helmet htmlAttributes={{ lang: config.language }}>
        <link rel="shortcut icon" type="image/png" href={favicon} />
      </Helmet>

      <div id="layout" className="layout">
        <Navigation handleUpdateTheme={handleUpdateTheme} theme={theme} />
        <Sidebar theme={theme} />
        <div className="main-wrapper">
          <div className="main-container">{children}</div>
          <Footer />
        </div>
      </div>
    </div>
  )
}
